var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useContext, useEffect, useState } from "react";
import { Outlet, useParams, useNavigate, useLocation } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { useVoterContext } from "../hooks/useVoterContext";
import { SettingsContext } from "../providers/SettingsContextProvider";
import { store } from "../store/store";
import { selectBallotStyleByElectionId } from "../store/ballotStyles/ballotStylesSlice";
import { useAppDispatch } from "../store/hooks";
import { setElection } from "../store/elections/electionsSlice";
import { setElectionEvent } from "../store/electionEvents/electionEventsSlice";
import { updateBallotStyleAndSelection } from "../services/BallotStyles";
export default function PublishedBallot() {
    var _a, _b;
    var _c = useParams(), tenantId = _c.tenantId, eventId = _c.eventId, electionId = _c.electionId;
    var globalSettings = useContext(SettingsContext).globalSettings;
    var context = useVoterContext(electionId);
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var search = useLocation().search;
    var _d = useState(), ready = _d[0], setReady = _d[1];
    useEffect(function () {
        var _a;
        if (!context.data)
            return;
        for (var _i = 0, _b = context.data.sequent_backend_election; _i < _b.length; _i++) {
            var election = _b[_i];
            dispatch(setElection(__assign(__assign({}, election), { image_document_id: "", contests: [], description: (_a = election.description) !== null && _a !== void 0 ? _a : undefined })));
        }
        for (var _c = 0, _d = context.data.sequent_backend_election_event; _c < _d.length; _c++) {
            var event = _d[_c];
            dispatch(setElectionEvent(event));
        }
        var incoming = context.data.sequent_backend_ballot_style[0];
        var existing = incoming
            ? selectBallotStyleByElectionId(incoming.election_id)(store.getState())
            : undefined;
        // Reauthentication may reload the same immutable style during review.
        // Retain its object and choices instead of resetting a vote in progress.
        if (incoming && (existing === null || existing === void 0 ? void 0 : existing.id) !== incoming.id) {
            updateBallotStyleAndSelection(context.data, dispatch);
            if (existing)
                navigate("/tenant/".concat(incoming.tenant_id, "/event/").concat(incoming.election_event_id, "/election/").concat(incoming.election_id, "/start").concat(search));
        }
        if (incoming)
            setReady({
                tenantId: incoming.tenant_id,
                eventId: incoming.election_event_id,
                electionId: incoming.election_id,
                styleId: incoming.id,
            });
    }, [context.data, dispatch, navigate, tenantId, eventId, electionId, search]);
    if (context.error)
        throw context.error;
    var incomingStyleId = (_b = (_a = context.data) === null || _a === void 0 ? void 0 : _a.sequent_backend_ballot_style[0]) === null || _b === void 0 ? void 0 : _b.id;
    // ApolloWrapper remounts children when the voter's authorization scope
    // changes. Within that scope, retain the current screen while refreshing
    // the same immutable ballot, including its pagination and receipt state.
    var hasReadyBallot = ready &&
        ready.tenantId === tenantId &&
        ready.eventId === eventId &&
        ready.electionId === electionId &&
        (!incomingStyleId || incomingStyleId === ready.styleId);
    if (!globalSettings.DISABLE_AUTH && !hasReadyBallot)
        return _jsx(CircularProgress, { className: "published-ballot-loading-progress" });
    return _jsx(Outlet, {});
}
